import React, { useState, useEffect } from 'react'
import { Box, Grid, TextField, Button, Typography, FormControl, FormControlLabel, InputLabel, Select, MenuItem, RadioGroup, FormLabel, Radio, FormGroup, Checkbox, Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import { ExpandMoreOutlined } from '@mui/icons-material'
import { handleSignUp } from '../Firebase/utils'
import { createTheme, ThemeProvider } from '@mui/material'
import { useSelector } from 'react-redux'
import { emailSignIn } from '../Redux/User/user.actions'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker'
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker'
import { firestore } from '../Firebase/utils'
import { useCollectionData } from 'react-firebase-hooks/firestore'

const mapUserDataState = ({user}) => ({
    userProfileData: user.userProfileData
})

export default function ReferralForm (){

    const [dateValue, setDateValue] = React.useState(dayjs(null));
    const [dorError, setDorError] = useState(null)
    const [nameError, setNameError] = useState('')
    const [viewReferrals, setViewReferrals] = useState(false)
    const { userProfileData } = useSelector(mapUserDataState)
    const referralsRef = firestore.collection('referrals')
    const query = referralsRef.orderBy('createdDate', 'desc')
    const [referrals] = useCollectionData(query)
    const genderValues = ['Male', 'Female']
    const pronounValues = ['He/Him', 'She/Her', 'They/Them', 'Other']
    const raceValues = ['White', 'Black or African American', 'Hispanic or Latino', 'Asian', 'American Indian or Alaska Native', 'Native Hawaiian or Other Pacific Islander', 'Middle Easterners and North Africans', 'Two or more races', 'Other']
    const phoneTypeValues = ['Mobile', 'Home', 'Work', 'Other']
    const leaveMessageValues = ['Yes', 'No']
    const previousCounselingValues = ['Yes', 'No', 'Not Sure']
    const relationshipValues = ['Parent', 'Guardian', 'Friend', 'Teacher', 'Counsler', 'Coach', 'Caregiver', 'Other']
    const educationValues = ['Some High School', 'High School Diploma', 'GED', 'Some College', 'Associates Degree', 'Bachelor\'s Degree', 'Masters Degree', 'Doctorate\'s Degree']
    const [formData, setFormData] = useState({
        consumerName:'',
        age:'',
        gender:'',
        pronouns:'',
        race:'',
        education:'',
        school:'',
        phoneNumber:'',
        phoneNumberType:'',
        leaveMessage:'',
        relationship:'',
        previousCounseling:'',
        previousCounselingType:'',
        personalHistory:'',
        personalHistoryDetails:'',
        familySensoryDisability:'',
        previousPsychologicalEvaluation:'',
        agencyName:'',
        requestorName:'',
        requestorTitle:'',
        requestorPhone:'',
        requestorEmail:'',
        collateralContactPhone:'',
        requestedServices:[], 
        presentingProblem:''
    })

    const handleChange = (newDateValue) => {
        setFormData({...formData, referralDate:{day: newDateValue?.date(), month: newDateValue?.month() + 1, year: newDateValue?.year() }})
        setDateValue(newDateValue)
        setDorError('')
    }

    const handleSubmit = async () => {
        await referralsRef.add({ formData, createdDate: new Date() })
        setFormData({
            consumerName:'',
            age:'',
            gender:'',
            pronouns:'',
            race:'',
            education:'',
            school:'',
            phoneNumber:'',
            phoneNumberType:'',
            leaveMessage:'',
            relationship:'',
            previousCounseling:'',
            previousCounselingType:'',
            personalHistory:'',
            personalHistoryDetails:'',
            familySensoryDisability:'',
            previousPsychologicalEvaluation:'',
            agencyName:'',
            requestorName:'',
            requestorTitle:'',
            requestorPhone:'',
            requestorEmail:'',
            collateralContactPhone:'',
            requestedServices:[...formData['requestedServices']], 
            presentingProblem:''
        })
    }

    const handleCheckboxChange = (e) => {
        
        if(!formData['requestedServices'].includes(e.target.name)){
            formData['requestedServices'].push(e.target.name)
        }else{
            const index = formData['requestedServices'].indexOf(e.target.name)
            if(index > -1)
            formData['requestedServices'].splice(index, 1)
        }
    }
    const resetErrors = () => {
        setNameError('')
    //     setEmailError('')
    //     setPasswordError('')
    //     setConfirmPasswordError('')
      }

    const textFieldStyle = {'& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: 'transparent',
          
          color:'#FFF'
        },
        '&:hover fieldset': {
          borderColor: '#36BAFE',
          color:'white'
        },
        '&.Mui-focused fieldset': {
          borderColor: '#36BAFE',
          color:'#FFF'
        },
        backgroundColor: '#262A34',
        color:'#FFF'
    }}

  return (
    <Box sx={{backgroundColor:'#181824', pt:6, pb:4}}>
            <Grid container direction='column'  alignItems='center' sx={{minHeight:'100vh', width:'100%', backgroundColor:'transparent'}}>
                <Grid item mb={5}>
                   <Typography variant='h4' fontWeight='bold' color='#FFF'>REFERRALS</Typography>
                </Grid>
                {userProfileData?.userRoles[0] === 'admin' && 
                <Grid item xs={11.5} md={12} pl={{xs:2, md:0}}>
                    <Button fullWidth size='large' variant='contained' color='primary' sx={{backgroundColor:'#36BAFE'}} onClick={() => {setViewReferrals(true)}}>
                        <Typography color='#FFF' fontWeight='bold' fontSize={25}>
                            View Referrals
                        </Typography>
                    </Button>
                </Grid>}
                {!viewReferrals ? <Grid container rowSpacing={2} mt={2}>
                    <Grid container item xs={12} spacing={{xs:1, md:2}} pl={{xs:2, md:0}}>
                        <Grid item xs={11.5} md={6}><TextField InputLabelProps={{style : {color : '#FFF'} }} sx={textFieldStyle} fullWidth error={nameError} helperText={nameError} label='Agency Requesting Referral' value={formData.agencyName} onChange={(e) => {setFormData({...formData, agencyName: e.target.value}); resetErrors()}}/></Grid>
                        <Grid item xs={11.5} md={6}><TextField InputLabelProps={{style : {color : '#FFF'} }} sx={textFieldStyle} fullWidth error={nameError} helperText={nameError} label='Name of Person making the referral' value={formData.requestorName} onChange={(e) => {setFormData({...formData, requestorName: e.target.value}); resetErrors()}}/></Grid>
                        <Grid item xs={11.5} md={6}><TextField InputLabelProps={{style : {color : '#FFF'} }} sx={textFieldStyle} fullWidth error={nameError} helperText={nameError} label='Title of Person making the referral' value={formData.requestorTitle} onChange={(e) => {setFormData({...formData,requestorTitle: e.target.value}); resetErrors()}}/></Grid>
                        <Grid item xs={11.5} md={6}><TextField InputLabelProps={{style : {color : '#FFF'} }} sx={textFieldStyle} fullWidth error={nameError} helperText={nameError} label='Phone Number of Person making the referral' type={'number'} value={formData.requestorPhone} onChange={(e) => {setFormData({...formData, requestorPhone: e.target.value}); resetErrors()}}/></Grid>
                        <Grid item xs={11.5} md={6}><TextField InputLabelProps={{style : {color : '#FFF'} }} sx={textFieldStyle} fullWidth error={nameError} helperText={nameError} label='Email of Person making the referral' type={'email'} value={formData.requestorEmail} onChange={(e) => {setFormData({...formData, requestorEmail: e.target.value}); resetErrors()}}/></Grid>
                        <Grid item xs={11.5} md={6}><TextField InputLabelProps={{style : {color : '#FFF'} }} sx={textFieldStyle} fullWidth error={nameError} helperText={nameError} label='Phone Number of Collateral Contact' type={'number'} value={formData.collateralContactPhone} onChange={(e) => {setFormData({...formData, collateralContactPhone: e.target.value}); resetErrors()}}/></Grid>
                    </Grid>
                    <Grid item container alignItems={{xs:'center', md:'left'}} justifyContent={{xs:'center', md:'left'}} xs={12} rowSpacing={{xs:1, md:2}} columnSpacing={{xs:1, md:1.5}}>
                        <Grid item  xs={11} md={6}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} >
                                <Box sx={{display:{xs:'none', md:'flex'}}}>
                                    <DesktopDatePicker
                                        label="DATE OF REFERRAL"
                                        inputFormat="MM/DD/YYYY"
                                        value={dateValue}
                                        onChange={handleChange}
                                        renderInput={(params) => 
                                        <TextField {...params} fullWidth InputLabelProps={{style : {color : '#FFF'} }} error={dorError} helperText={dorError} sx={textFieldStyle}/>}
                                    />
                                </Box>
                                <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                                        <MobileDatePicker
                                            label="DATE OF REFERRAL"
                                            inputFormat="MM/DD/YYYY"
                                            value={dateValue}
                                            onChange={handleChange}
                                            renderInput={(params) => 
                                            <TextField fullWidth {...params} InputLabelProps={{style : {color : '#FFF'} }} error={dorError} helperText={dorError} sx={textFieldStyle}/>}
                                        />
                                </Box>
                          </LocalizationProvider>
                        </Grid>
                        <Grid item xs={11} md={6}><TextField InputLabelProps={{style : {color : '#FFF'} }} sx={textFieldStyle} fullWidth error={nameError} helperText={nameError} label='CONSUMER NAME' value={formData.firstName} onChange={(e) => {setFormData({...formData, consumerName: e.target.value}); resetErrors()}}/></Grid>
                        <Grid item xs={5.5} md={3}><TextField InputLabelProps={{style : {color : '#FFF'} }} sx={textFieldStyle} fullWidth error={nameError} helperText={nameError} type='number' label='AGE' value={formData.age} onChange={(e) => {setFormData({...formData, age: e.target.value}); resetErrors()}}/></Grid>
                        <Grid item xs={5.5} md={3}>
                            <DropDown menuItems={genderValues} label={'GENDER'} value={formData.gender} wholeState={formData} targetState={'gender'} setTargetState={setFormData}/>
                        </Grid>
                        <Grid item xs={5.5} md={3}>
                            <DropDown menuItems={pronounValues} label={'PRONOUNS'} value={formData.pronouns} wholeState={formData} targetState={'pronouns'} setTargetState={setFormData}/>
                        </Grid>
                        <Grid item xs={5.5} md={3}>
                            <DropDown menuItems={raceValues} label={'RACE'} value={formData.race} wholeState={formData} targetState={'race'} name='race' setTargetState={setFormData}/>
                        </Grid>
                        <Grid item xs={11} md={6}>
                            <DropDown menuItems={educationValues} label={'Highest Level of Education'} value={formData.education} wholeState={formData} targetState={'education'} setTargetState={setFormData}/>
                        </Grid>
                        <Grid item xs={11} md={6}><TextField InputLabelProps={{style : {color : '#FFF'} }} sx={textFieldStyle} fullWidth error={nameError} helperText={nameError} label='School (If Applicable)' value={formData.school} onChange={(e) => {setFormData({...formData, school: e.target.value}); resetErrors()}}/></Grid>
                        <Grid item xs={11} md={6}><TextField InputLabelProps={{style : {color : '#FFF'} }} sx={textFieldStyle} fullWidth error={nameError} helperText={nameError} type='number' label='Phone' value={formData.phoneNumber} onChange={(e) => {setFormData({...formData, phoneNumber: e.target.value}); resetErrors()}}/></Grid>
                        <Grid item xs={11} md={6}>
                            <DropDown menuItems={phoneTypeValues} label={'Phone Type'} value={formData.phoneNumberType} wholeState={formData} targetState={'phoneNumberType'} setTargetState={setFormData}/>
                        </Grid>
                        <Grid item container justifyContent='space-between' alignItems='center' xs={11} md={6}>
                            <Grid item><Typography color='#FFF'>May We Leave a Message?</Typography></Grid>
                            <Grid item><RadioForm menuItems={leaveMessageValues} label={''} value={formData.leaveMessage} wholeState={formData} targetState={'leaveMessage'} setTargetState={setFormData}/></Grid>
                        </Grid>
                        <Grid item xs={11} md={6}>
                            <DropDown menuItems={relationshipValues} label={'Relationship to Consumer'} value={formData.relationship} wholeState={formData} targetState={'relationship'} setTargetState={setFormData}/>
                        </Grid>
                    </Grid>
                    <Grid item container alignItems={{xs:'left', md:'left'}} justifyContent={{xs:'left', md:'left'}} xs={12} pl={{xs:2, md:0}} rowSpacing={{xs:1, md:2}} columnSpacing={{xs:1, md:1.5}}>
                        <Grid item pl={2}>
                            <Typography color={'#36BAFE'} fontSize={{xs:20}} fontWeight='bold'>Other Services Sought</Typography>
                        </Grid>
                        <Grid container item xs={12}>
                            <Grid item xs={11.5}><Typography color={'#FFF'}  fontWeight='bold'>1. Has the child or adult had other services (e.g. Community Support Individual-CSI, Individual and/or Family Counsling)?</Typography></Grid>
                            <Grid item md={12}><RadioForm menuItems={previousCounselingValues} label={''} value={formData.previousCounseling} wholeState={formData} targetState={'previousCounseling'} setTargetState={setFormData}/></Grid>
                            <Grid item xs={11.5} md={6}><TextField InputLabelProps={{style : {color : '#FFF'} }} sx={textFieldStyle} fullWidth error={nameError} helperText={nameError} label='What Type?' value={formData.previousCounselingType} onChange={(e) => {setFormData({...formData, previousCounselingType: e.target.value}); resetErrors()}}/></Grid>
                        </Grid>
                        <Grid container item xs={12}>
                            <Grid item xs={11.5}><Typography color={'#FFF'}  fontWeight='bold'>2. Does the child or adult have a known Serious Emotional Disturbance and/or Substance Abuse issue/diagnosis?</Typography></Grid>
                            <Grid item md={12}><RadioForm menuItems={previousCounselingValues} label={''} value={formData.personalHistory} wholeState={formData} targetState={'personalHistory'} setTargetState={setFormData}/></Grid>
                            <Grid item xs={11.5} md={6}><TextField InputLabelProps={{style : {color : '#FFF'} }} sx={textFieldStyle} fullWidth error={nameError} helperText={nameError} label='Details' value={formData.personalHistoryDetails} onChange={(e) => {setFormData({...formData, personalHistoryDetails: e.target.value}); resetErrors()}}/></Grid>
                        </Grid>
                        <Grid container item xs={12}>
                            <Grid item xs={11.5}><Typography color={'#FFF'}  fontWeight='bold'>3. Are child and/or family members diagnosed with Sensory Disabilities?</Typography></Grid>
                            <Grid item md={12}><RadioForm menuItems={leaveMessageValues} label={''} value={formData.familySensoryDisability} wholeState={formData} targetState={'familySensoryDisability'} setTargetState={setFormData}/></Grid>
                        </Grid>
                        <Grid container item xs={12}>
                            <Grid item xs={11.5}><Typography color={'#FFF'}  fontWeight='bold'>4. Has Psychological/Psychiatric Evaluation been completed?</Typography></Grid>
                            <Grid item md={12}><RadioForm menuItems={leaveMessageValues} label={''} value={formData.previousPsychologicalEvaluation} wholeState={formData} targetState={'previousPsychologicalEvaluation'} setTargetState={setFormData}/></Grid>
                        </Grid>
                    </Grid>
                    <Grid item container alignItems={{xs:'left', md:'left'}} justifyContent={{xs:'left', md:'left'}} xs={12} pl={{xs:2, md:0}} rowSpacing={{xs:1, md:2}} columnSpacing={{xs:1, md:1.5}}>
                        <Grid item pl={2}>
                            <Typography color={'#36BAFE'} fontSize={{xs:20}} fontWeight='bold'>Service(s) Requested (Please Check)</Typography>
                        </Grid>
                        <Grid container item xs={12}>
                            <Grid item md={12}>
                                <FormGroup fullWidth color='#FFF'>
                                    <FormControlLabel style={{color:'#FFF'}} onChange={handleCheckboxChange} control={<Checkbox style={{color:'#36BAFE'}}/>} name='Individual/Family Therapy' label='Individual/Family Therapy' />
                                    <FormControlLabel style={{color:'#FFF'}} onChange={handleCheckboxChange} control={<Checkbox style={{color:'#36BAFE'}}/>} name='Intensive Family Intervention' label='Intensive Family Intervention' />
                                    <FormControlLabel style={{color:'#FFF'}} onChange={handleCheckboxChange} control={<Checkbox style={{color:'#36BAFE'}}/>} name='Limited Vocational Evaluation (VR)' label='Limited Vocational Evaluation (VR)' />
                                    <FormControlLabel style={{color:'#FFF'}} onChange={handleCheckboxChange} control={<Checkbox style={{color:'#36BAFE'}}/>} name='Comprehensive Vocational Profile (VR)' label='Comprehensive Vocational Profile (VR)' />
                                    <FormControlLabel style={{color:'#FFF'}} onChange={handleCheckboxChange} control={<Checkbox style={{color:'#36BAFE'}}/>} name='CSI - Life Skills' label='CSI - Life Skills' />
                                    <FormControlLabel style={{color:'#FFF'}} onChange={handleCheckboxChange} control={<Checkbox style={{color:'#36BAFE'}}/>} name='Innovative Parenting Program' label='Innovative Parenting Program' />
                                    <FormControlLabel style={{color:'#FFF'}} onChange={handleCheckboxChange} control={<Checkbox style={{color:'#36BAFE'}}/>} name='Job Readiness Training (VR)' label='Job Readiness Training (VR)' />
                            </FormGroup>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item container alignItems={{xs:'left', md:'left'}} justifyContent={{xs:'left', md:'left'}} xs={12} pl={{xs:2, md:0}} rowSpacing={{xs:1, md:2}} columnSpacing={{xs:1, md:1.5}}>
                        <Grid item pl={2}>
                            <Typography color={'#36BAFE'} fontSize={{xs:20}} fontWeight='bold'>Presenting Problem</Typography>
                        </Grid>
                        <Grid item pl={2}>
                            <Grid item xs={11.5}><Typography color={'#FFF'} >Problem behaviors; Present limitations; Adequate housing and transportation; include any medications for emotional and/or behavior problems:</Typography></Grid>
                        </Grid>
                        <Grid item xs={11.5} md={12}>
                            <TextField multiline rows={6} InputLabelProps={{style : {color : '#FFF'} }} sx={textFieldStyle} fullWidth error={nameError} helperText={nameError} label='State here' value={formData.presentingProblem} onChange={(e) => {setFormData({...formData, presentingProblem: e.target.value}); resetErrors()}}/>
                        </Grid>
                    </Grid>
                    <Grid item xs={11.5} md={12} pl={{xs:2, md:0}}>
                        <Button fullWidth size='large' variant='contained' color='primary' sx={{backgroundColor:'#36BAFE'}} onClick={() => handleSubmit()}>
                            <Typography color='#FFF' fontWeight='bold' fontSize={25}>
                                SUBMIT
                            </Typography>
                        </Button>
                    </Grid>
                </Grid> : <ViewReferrals referrals={referrals}/>}
            </Grid>
        </Box>
  )
}

const DropDown = (props) => {

    const { menuItems, label, value, wholeState, targetState, setTargetState } = props

    const handleChange = (e) => {
        const obj = wholeState[targetState] = e.target.value
        setTargetState({...wholeState, obj});
    }

    return(
        <FormControl fullWidth>
            <InputLabel id="select-label" sx={{color: '#FFF', width:'100%', '&.Mui-focused': {color:'#transparent'} }}>{label}</InputLabel>
            <Select
                fullWidth
                labelId="select-label"
                id="select"
                value={value}
                label={label}
                onChange={handleChange}
                size='large'
                sx={{
                color: "#FFF",
                backgroundColor:'#262A34',
                '.MuiOutlinedInput-notchedOutline': {
                borderColor: 'transparent',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#36BAFE',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#36BAFE',
                },
                '.MuiSvgIcon-root ': {
                fill: "#262A34 !important",
                }
                }}
                >
                {menuItems.map((item, index) => {
                return (<MenuItem key={index} value={`${item}`}>{item}</MenuItem>)
                })}
            </Select>
        </FormControl>
    )
}

const RadioForm = (props) => {
    const { menuItems, label, value, wholeState, targetState, setTargetState } = props

    const handleChange = (e) => {
        const obj = wholeState[targetState] = e.target.value
        setTargetState({...wholeState, obj:e.target.value});
    }
    return (
        <FormControl fullWidth>
            <FormLabel id="select-label" sx={{color: '#FFF', width:'100%', '&.Mui-focused': {color:'#transparent'} }}>{label}</FormLabel>
            <RadioGroup
            row
                fullWidth
                labelId="select-label"
                id="select"
                value={value}
                label={label}
                onChange={handleChange}
                size='large'
                sx={{
                color: "#FFF"
                }}>{menuItems.map((item, index) => {
                    return (<FormControlLabel key={index} value={`${item}`} control={<Radio style={{color:'#36BAFE'}}/>} orientation='horizontal' label={`${item}`}>{item}</FormControlLabel>)
                    })}
            </RadioGroup>
        </FormControl>
    )
}

const ViewReferrals = (props) => {

    const { referrals } = props

    return(
        <Grid container pt={2}>
            {referrals.map((i, index) => {
                return(
                    <Grid item key={index} xs={12}>
                        <Accordion key={index} sx={{backgroundColor:'#262A34', p:2, border:'#36BAFE solid 1px'}}>
                            <AccordionSummary>
                                <Typography fontSize={15} color='#36BAFE'>{`Referral For: ${i.formData.consumerName} By: ${i.formData.requestorName} at ${i.formData.agencyName} submitted ${new Date(i.createdDate.seconds * 1000).toDateString()} ${new Date(i.createdDate.seconds * 1000).toLocaleTimeString()}`}</Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{backgroundColor:'GrayText'}}>
                                <Grid container direction={'row'} >
                                    <Grid item pr={10}>
                                        <Typography color={'#36BAFE'} fontWeight={'bold'} fontSize={{xs:20, md:30}}>Consumer Information</Typography>
                                        <DataDisplay title='Consumer Name' data={i.formData.consumerName} />
                                        <DataDisplay title='Gender' data={i.formData.gender} />
                                        <DataDisplay title='Race' data={i.formData.race} />
                                        <DataDisplay title='Age' data={i.formData.age} />
                                        <DataDisplay title='Pronouns' data={i.formData.pronouns} />
                                        <DataDisplay title='Education' data={i.formData.education} />
                                        <DataDisplay title='School' data={i.formData.school} />
                                        <DataDisplay title='Phone' data={i.formData.phoneNumber} />
                                        <DataDisplay title='Phone Type' data={i.formData.phoneNumberType} />
                                        <DataDisplay title='Leave a Message?' data={i.formData.leaveMessage} />
                                        <DataDisplay title='Relationship' data={i.formData.relationship} />
                                    </Grid>
                                    <Grid item>
                                        <Typography color={'#36BAFE'} fontWeight={'bold'} fontSize={{xs:20, md:30}}>Requestor/Agency Information</Typography>
                                        <DataDisplay title='Agency Name' data={i.formData.agencyName} />
                                        <DataDisplay title='Requestor Name' data={i.formData.requestorName} />
                                        <DataDisplay title='Requestor Title' data={i.formData.requestorTitle} />
                                        <DataDisplay title='Requestor Email' data={i.formData.requestorEmail} />
                                        <DataDisplay title='Requestor Phone' data={i.formData.requestorPhone} />
                                        <DataDisplay title='Collateral Phone' data={i.formData.collateralContactPhone} />
                                    </Grid>
                                </Grid>
                                <Grid container pt={4}>
                                    <Grid item>
                                        <Typography color={'#36BAFE'} fontWeight={'bold'} fontSize={{xs:20, md:30}}>Referral Details</Typography>
                                        <DataDisplay title='Previous Counseling' data={i.formData.previousCounseling} />
                                        <DataDisplay title='Previous Counseling Details' data={i.formData.previousCounselingType} />
                                        <DataDisplay title='Emotional Disturbance/Substance Abuse History' data={i.formData.personalHistory} />
                                        <DataDisplay title='Emotional Disturbance/Substance Abuse History Details' data={i.formData.personalHistoryDetails} />
                                        <DataDisplay title='Family Sensory Disability History' data={i.formData.familySensoryDisability} />
                                        <DataDisplay title='Previous Psychological/Psychiatric Evaluation' data={i.formData.previousPsychologicalEvaluation} />
                                        <Grid item container direction={'column'} columnSpacing={1}>
                                            <Grid item><Typography color='white' fontWeight='bold'>Requested Services:</Typography></Grid>
                                            {i.formData.requestedServices.map((requestedService, index) => {
                                                return(<Grid key={index} item ><Typography key={index} color='#36BAFE'>{requestedService}</Typography></Grid>)
                                            })}
                                        </Grid>
                                        <DataDisplay title='Presenting Problem' data={i.formData.presentingProblem} />
                                    </Grid>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>
                    </Grid>
                )
            })}
        </Grid>
    )
}

const DataDisplay = (props) => {
    const { title, data } = props
    
        return (
        <Grid item container columnSpacing={1}>
            <Grid item><Typography color='white' fontWeight='bold'>{title}:</Typography></Grid>
            <Grid item><Typography color='#36BAFE'>{data}</Typography></Grid>
        </Grid>)


    
}